import { useTranslation } from 'react-i18next';
import { useConfirm } from './confirm/useConfirm';
import type { IRecordEditor } from './IRecordEditor';
import type { IRecordGuard } from './IRecordGuard';
import { useLeaveGuard } from './useLeaveGuard';

/**
 * Захист чернетки сторінки запису (UIUX patterns/confirmations): діалог підтвердження застосунку і «Скасувати ваші зміни?» перед
 * переходом за межі сторінки (`base` — адреса запису; її вкладки лишаються на сторінці).
 */
export function useRecordGuard(editor: IRecordEditor, base: string): IRecordGuard {
  const { t } = useTranslation();
  const { confirm, dialog } = useConfirm();
  const release = useLeaveGuard(editor.dirty, () => confirm({
    title: t('recordPage.confirmDiscardTitle'), text: t('recordPage.confirmDiscard', { count: editor.dirtyKeys.length }),
    confirmLabel: t('recordPage.discard'), cancelLabel: t('recordPage.keepEditing'), danger: true,
  }), (path) => path === base || path.startsWith(`${base}/`));
  return { confirm, dialog, release };
}
